import { IParkingProductsQuoteCreateResponse } from '../../../../../shared/api/gateway/types';
import { ParkingProductTransferDetailsType } from '../../models/IParkingProduct';
import { IGetAmendParkingProductsResponse } from '../../../../../shared/api/gateway/types/IGetAmendParkingProductsResponse';

export function adaptAmendResponseToParkingProductsQuoteResponse(
	response: IGetAmendParkingProductsResponse,
): IParkingProductsQuoteCreateResponse {
	if (!response.parkingProducts.length) {
		throw new Error('No parking products returned for amend quote response.');
	}

	return {
		...response,
		parkingProducts: response.parkingProducts.map((parkingProduct) => ({
			id: parkingProduct.id,
			key: parkingProduct.key,
			totalPrice: parkingProduct.totalPrice,
			priceDifference: parkingProduct.priceDifference,
			priceDifferenceType:
				parkingProduct.priceDifferenceType === 'Charge' ||
				parkingProduct.priceDifferenceType === 'Refund'
					? parkingProduct.priceDifferenceType
					: undefined,
			name: parkingProduct.name,
			features: parkingProduct.features ?? [],
			description: parkingProduct.description ?? '',
			logo: parkingProduct.logo,
			map: parkingProduct.map,
			price: parkingProduct.price,
			transferDetails: {
				type: getTransferType(parkingProduct.transferDetails?.type),
				time: parkingProduct.transferDetails?.time,
				description: parkingProduct.transferDetails?.description,
			},
			availability: {
				isAvailable: parkingProduct.availability.isAvailable,
				message: parkingProduct.availability.message,
			},
			loyaltyPoints: parkingProduct.loyaltyPoints,
			spotsRemainingForPrice: parkingProduct.spotsRemainingForPrice,
		})),
	};
}
function getTransferType(
	transferType?: string,
): ParkingProductTransferDetailsType | undefined {
	if (
		transferType === 'Bus' ||
		transferType === 'Walk' ||
		transferType === 'Train'
	) {
		return transferType;
	}

	return undefined;
}
